import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, ArrowDown } from 'lucide-react';
export function ProblemSection() {
  return <section className="px-4 py-20 max-w-3xl mx-auto" data-id="element-272">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="space-y-12" data-id="element-273">
        {/* The Real Problem */}
        <div className="text-center" data-id="element-274">
          <div className="inline-flex items-center justify-center p-3 bg-brand-yellow/10 rounded-full mb-6" data-id="element-275">
            <AlertTriangle className="text-brand-yellow w-8 h-8" data-id="element-276" />
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold uppercase mb-6 leading-tight" data-id="element-277">
            El problema real no es que no tengas ideas
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-278">
            El problema real es que estás haciendo esto:
          </p>
          <div className="my-8 font-display text-2xl md:text-3xl text-white font-bold bg-brand-surface p-6 rounded-lg border border-gray-800 inline-block" data-id="element-279">
            Consumir información <span className="text-gray-500" data-id="element-280">→</span>{' '}
            Guardar ideas <span className="text-gray-500" data-id="element-281">→</span> Sentirte peor{' '}
            <span className="text-gray-500" data-id="element-282">→</span> No ejecutar.
          </div>
        </div>

        {/* The Gap */}
        

        {/* Why old solutions fail */}
        <div className="text-center pt-8" data-id="element-283">
          <h3 className="font-display text-3xl font-bold text-white mb-6" data-id="element-284">
            Por qué lo que ya intentaste no funcionó
          </h3>
          <p className="text-gray-400 text-lg mb-8" data-id="element-285">
            Porque te daban piezas sueltas: "Haz contenido", "Vende un
            servicio", "Sé constante". Pero nunca te dieron el puente entre{' '}
            <span className="text-white font-bold" data-id="element-286">"quiero"</span> y{' '}
            <span className="text-brand-yellow font-bold" data-id="element-287">"me pagaron"</span>.
          </p>

          <div className="flex justify-center" data-id="element-288">
            <ArrowDown className="text-brand-yellow animate-bounce w-10 h-10" data-id="element-289" />
          </div>
        </div>
      </motion.div>
    </section>;
}